<template>
    <li class="card-item bucket-list-card-item">
        <div
            :class="[
                'image-wrapper',
                `icon-${$iconGet('bucketListType', bucketList.type)}`,
            ]"
        >
            <ExternalImage v-if="!!image_url" :src="image_url" />
            <span class="icon material-symbols-outlined">
                {{ $iconGet("bucketListType", bucketList.type) }}
            </span>
        </div>
        <div class="card-data">
            <h2 class="bucket-list-title">{{ bucketList.name }}</h2>
            <div class="status">
                <span
                    v-if="isCompleted"
                    class="icon-check material-symbols-outlined"
                >
                    done
                </span>
                <span>{{ checked }}/{{ total }}</span>
            </div>
        </div>
        <router-link
            :to="`/bucket-lists/${bucketList.id}`"
            class="fill-space"
        />
    </li>
</template>

<script>
import ExternalImage from "js/components/common/ExternalImage.vue";

export default {
    name: "BucketListCardItem",
    components: {
        ExternalImage,
    },
    props: {
        bucketList: {
            type: Object,
            required: true,
        },
    },
    computed: {
        items() {
            return this.bucketList.items || [];
        },
        total() {
            return this.items.length;
        },
        checked() {
            return this.items.reduce(
                (prev, item) => prev + (item.checked ? 1 : 0),
                0
            );
        },
        image_url() {
            return (this.items.find((el) => !!el.image_url) || {}).image_url;
        },
        isCompleted() {
            return this.total === this.checked;
        },
    },
};
</script>
